export default __webpack_public_path__ + "static/media/avatar-bts-jin.00b80135.png";